<script setup lang="ts">
import { nodeViewProps, NodeViewWrapper, NodeViewContent } from "@tiptap/vue-3";
import { MailMjmlText } from "#components";
import {
    createParagraphBlock,
    createDocumentBlock,
} from "~/stores/mail-block-editor/defaults";
import type { DocumentBlock } from "~/types/MailBlocks";

const props = defineProps(nodeViewProps);
const store = useMailStore();
const builder = useMailStore();
const theme = computed(() => {
    const doc = createDocumentBlock(store.jsonData as DocumentBlock);
    const theme = createParagraphBlock();
    const linkColor = props.node.attrs?.linkColor ?? theme?.linkColor;
    const linkUnderlined =
        props.node.attrs?.linkUnderlined ?? theme?.linkUnderlined;

    return builder.fieldCollection.replaceContent({
        paddingTop: props.node.attrs?.marginTop,
        paddingBottom: props.node.attrs?.marginBottom,
        alignment: props.node.attrs?.alignment,
        textColor: props.node.attrs?.textColor ?? theme?.textColor,
        linkColor:
            !linkColor || linkColor === "inherit" ? doc.linkColor : linkColor,
        linkUnderlined:
            !linkUnderlined || linkUnderlined === "inherit"
                ? doc.linkUnderlined
                : linkUnderlined,
        fontFamily: props.node.attrs?.fontFamily ?? theme?.fontFamily,
        fontSize: props.node.attrs?.fontSize ?? theme?.fontSize,
        fontWeight: props.node.attrs?.fontWeight ?? theme?.fontWeight,
        lineHeight: props.node.attrs?.lineHeight ?? theme?.lineHeight,
        letterSpacing: props.node.attrs?.letterSpacing ?? theme?.letterSpacing,
    });
});
</script>

<template>
    <NodeViewWrapper
        class="paragraph"
        :style="{
            '--link-color': theme.linkColor,
            '--link-underlined': theme.linkUnderlined ? 'underline' : 'inherit',
        }"
        @click.stop="store.focusedJsonId = node.attrs.id"
        @focusin.stop="store.focusedJsonId = node.attrs.id"
        :as="MailMjmlText"
        :color="theme.textColor"
        :padding-top="theme.paddingTop"
        :padding-vottom="theme.paddingBottom"
        :class="theme.fontFamily ? `font-${theme.fontFamily}` : undefined"
        :fontSize="theme.fontSize"
        :align="theme.alignment"
        :fontWeight="theme.fontWeight?.toString()"
        :lineHeight="theme.lineHeight?.toString()"
        :letterSpacing="theme.letterSpacing?.toString()"
    >
        <NodeViewContent />
    </NodeViewWrapper>
</template>

<style scoped>
.paragraph[data-placeholder] {
    position: relative;
}

.paragraph[data-placeholder]::after {
    position: absolute;
    left: 0;
    color: #adb5bd;
    background: blue;
    content: attr(data-placeholder);
    height: 0;
    display: block;
    white-space: nowrap !important;
    font-size: 1rem;
    pointer-events: none;
}

.paragraph :deep(a) {
    color: var(--link-color) !important;
    text-decoration: var(--link-underlined) !important;
}
</style>
